"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeatureToggles = useFeatureToggles;
var _react = require("react");
var _featureTogglesContext = require("./featureTogglesContext");
/** @deprecated Use the `useFeatureToggles` function from the `@ori/feature-toggles` library */
function useFeatureToggles() {
  const features = (0, _react.useContext)(_featureTogglesContext.featureTogglesContext);
  return (0, _react.useMemo)(() => ({
    features,
    isFeatureEnabled: feature => features.includes(feature)
  }), [features]);
}
